const STORAGE_KEY = 'wika-theme';

function storedTheme() {
  try {
    const value = localStorage.getItem(STORAGE_KEY);
    return value === 'light' || value === 'dark' ? value : null;
  } catch {
    return null;
  }
}

function applyTheme(theme) {
  const root = document.documentElement;
  const dark = theme === 'dark';
  root.classList.add('no-theme-transition');
  root.classList.toggle('dark', dark);
  root.style.colorScheme = dark ? 'dark' : 'light';
  document.querySelector('meta[name="theme-color"]')?.setAttribute('content', dark ? '#09090b' : '#f4f4f5');
  document.querySelectorAll('[data-theme-toggle]').forEach((button) => {
    button.setAttribute('aria-pressed', dark ? 'true' : 'false');
    button.setAttribute('aria-label', dark ? 'Switch to light mode' : 'Switch to dark mode');
  });
  requestAnimationFrame(() => {
    requestAnimationFrame(() => {
      root.classList.remove('no-theme-transition');
    });
  });
}

/** Persists an explicit light or dark choice. Until then, the OS setting still applies. */
export function initTheme() {
  const media = window.matchMedia('(prefers-color-scheme: dark)');
  const followSystem = () => {
    if (storedTheme()) return;
    applyTheme(media.matches ? 'dark' : 'light');
  };

  applyTheme(storedTheme() ?? (media.matches ? 'dark' : 'light'));
  media.addEventListener('change', followSystem);

  document.addEventListener('click', (event) => {
    const button = event.target.closest('[data-theme-toggle]');
    if (!button) return;
    const next = document.documentElement.classList.contains('dark') ? 'light' : 'dark';
    try {
      localStorage.setItem(STORAGE_KEY, next);
    } catch {
      /* Private mode can block storage; the choice still applies for this view. */
    }
    applyTheme(next);
  });
}
